<div class="engagement-panel">
  @if (openRequestEngagementPopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin"
      >
      <div #popupContent class="add-client-container" >
        <div class="popup-header">
          <div class="popup-title">Request Engagement</div>
          <button class="close-btn" (click)="close()">&#x2715;</button>
        </div>
        @if (isSearchSelected) {
          <div>
            <div class="label">Engagement Name or Number</div>
            <div class="search-area">
              <!-- <kendo-autocomplete  [data]="engagementListDetails" style="width:550px;margin-right: 10px;"
              [filterable]="true"
              (filterChange)="searchByEngagementNameOrNumber($event)"
              >
              <ng-template kendoPrefixTemplate>
                <button kendoButton fillMode="flat" [svgIcon]="searchIcon"></button>
              </ng-template>
            </kendo-autocomplete> -->
            <kendo-textbox
              [fillMode]="'outline'"
              style="width: 550px; margin-right: 10px"
              [clearButton]="true"
              placeholder="Search..."
              [value]="searchText"
            (valueChange)="
              onSearchInputChange($event)
            "
              >
              <ng-template kendoTextBoxPrefixTemplate>
                <kendo-svgicon [icon]="searchIcon"></kendo-svgicon>
              </ng-template>
            </kendo-textbox>
            <button
              kendoButton
              type="button"
              [svgIcon]="playIcon"
              (click)="getEngagementDetailsByEngagementNameOrNumber()"
              class="play-btn"
            ></button>
          </div>
        </div>
      }
      @if (isSearchSelected) {
        <div
          style="margin-top: 10px"
          >
          <div style="color:red">{{errorMessage}}</div>
          @if (!selectedEngagementNumber && searchText.length>=3 && !errorMessage && !isDisplayloaderSearch) {
            <div>
              {{
              searchedEngagementDetails.length +
              " " +
              "Results for" +
              " " +
              searchText
              }}
            </div>
          }
          @if (isSearchSelected && searchText.length>=3 && !errorMessage) {
            <div class="search-results-section">
              @if (isDisplayloaderSearch) {
                <div class="setloader-position">
                  <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                    size="default"
                    color="#225EFF"
                    type="ball-triangle-path" [fullScreen]="false">
                  </ngx-spinner>
                </div>
              }
              @for (data of searchedEngagementDetails; track data) {
                <div>
                  <button
                    kendoButton
                    fillMode="clear"
                    class="search-list"
                    (click)="onSelectedEngagement(data.engagementNumber)"
                    >
                    {{ data.engagementNumber + " " + data.engagementName }}
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!isSearchSelected && selectedEngagementDetail) {
        <div>
          @if (isDisplayloader) {
            <div class="setloader-position"
              >
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </div>
          }
          @if (!isDisplayloader) {
            <div class="engagement-details-section" style="z-index: 98;">
              @if (engagementRequestDetailsForm) {
                <form
                  class="k-form k-form-md"
                  [formGroup]="engagementRequestDetailsForm"
                  >
                  <div class="wrapper">
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Engagement</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Status"></kendo-label>
                              <h4 class="ellipse">{{ selectedEngagementDetail.engagementStatus }} </h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Number"></kendo-label>
                              <h4 class="ellipse">{{ selectedEngagementDetail.engagementNumber }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Name"></kendo-label>
                              <div class="ellipse"
                                kendoTooltip
                                filter="h4"
                                >
                                <h4 class="ellipse" title="{{ selectedEngagementDetail.engagementName }}">{{ selectedEngagementDetail.engagementName }}</h4>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Type"></kendo-label>
                              <h4 class="ellipse">{{ selectedEngagementDetail.engagementType }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Created Date"></kendo-label>
                              <h4 class="ellipse">{{ selectedEngagementDetail.engagementCreatedDate | kendoDate: "MM/dd/yyyy" }}</h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Close Date"></kendo-label>
                              <h4 class="ellipse">{{ selectedEngagementDetail.engagementClosedDate !== null ? (selectedEngagementDetail.engagementClosedDate | kendoDate: "MM/dd/yyyy") : '--/--/----' }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Client Code"></kendo-label>
                              <h4 class="ellipse" style="margin-bottom: 0px">{{ selectedEngagementDetail.clientCode }}</h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Client Name"></kendo-label>
                              <div class="ellipse"
                                kendoTooltip
                                filter="h4"
                                >
                                <h4 class="ellipse" style="margin-bottom: 0px" title="{{ selectedEngagementDetail.clientName }}">{{ selectedEngagementDetail.clientName }}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Function and Service Details</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Profit Centre Code"></kendo-label>
                            <h4>
                              {{ selectedEngagementDetail.profitCenterCode }}
                            </h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Profit Centre Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" title="{{ selectedEngagementDetail.profitCenterDescription }}">
                                {{ selectedEngagementDetail.profitCenterDescription }}
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Function Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4  class="ellipse" title="{{ selectedEngagementDetail.functionDescription }}">
                                {{ selectedEngagementDetail.functionDescription }}
                              </h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Offering Group Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" title="{{ selectedEngagementDetail.serviceGroupDescription }}">
                                {{ selectedEngagementDetail.serviceGroupDescription }}
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Offering Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" style="margin-bottom: 0px" title="{{ selectedEngagementDetail.serviceLineDescription }}">
                                {{ selectedEngagementDetail.serviceLineDescription }}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Contacts</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Engagement Partner"></kendo-label>
                            <h4 class="ellipse">{{ selectedEngagementDetail.engagementPartnerName }}</h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Partner Email"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 style="color: #00338d" class="ellipse" title="{{ selectedEngagementDetail.engagementPartnerEmailAddress }}">
                                <a href="mailto:{{ selectedEngagementDetail.engagementPartnerEmailAddress }}"
                                  style="color: #00338d; text-decoration: none;">
                                  {{ selectedEngagementDetail.engagementPartnerEmailAddress }}
                                </a>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Engagement Manager"></kendo-label>
                            <h4 style="margin-bottom: 0px" class="ellipse">{{ selectedEngagementDetail.engagementManagerName }}</h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Manager Email"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 style="color: #00338d; margin-bottom: 0px" class="ellipse" title="{{ selectedEngagementDetail.engagementManagerEmailAddress }}">
                                <a href="mailto:{{ selectedEngagementDetail.engagementManagerEmailAddress }}"
                                  style="color: #00338d; text-decoration: none;">
                                  {{ selectedEngagementDetail.engagementManagerEmailAddress }}
                                </a>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <div>
                      <kendo-label text="Comments ">
                        <span><i>(Optional)</i></span>
                      </kendo-label>
                      <kendo-textarea formControlName="RequestUserComment"
                        placeholder="Comments"
                        fillMode="none"
                        class="custom-textarea"
                        [rows]="3"
                      resizable="vertical"  [maxlength]="256"></kendo-textarea>
                    </div>
                  </div>
                </form>
              }
            </div>
          }
          @if (!isDisplayloader) {
            <div class="form-buttons">
              @if (isAutoApprove) {
                <button
                  kendoButton
                  type="button"
                  (click)="createEngagementRequestDetails()"
                  class="request-button"
                  themeColor="none"
                  >
                  REQUEST & APPROVE
                </button>
              }
              @if (!isAutoApprove) {
                <button
                  kendoButton
                  type="button"
                  (click)="createEngagementRequestDetails()"
                  class="request-button"
                  >
                  REQUEST
                </button>
              }
              <button
                kendoButton
                type="button"
                (click)="cancelEngagementRequestDetails()"
                class="w-100"
                >
                CANCEL
              </button>
            </div>
          }
        </div>
      }
    </div>
  </kendo-popup>
}
@if (openRequestEngagementPopup) {
  <div class="k-popup-backdrop"></div>
}
</div>
